import React, { useRef, useEffect, useState } from "react";
import { Draggable } from "@fullcalendar/interaction";
import { Paper, Typography, Avatar, Box, Stack, Collapse, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp, Visibility } from "@mui/icons-material";
import WO from "./WorkorderView/WO";

import ResponsiveDialog from "../../../Component/ResponsiveDialog";
const ExternalEvent = ({ event,onClick }) => {
  const dragRef = useRef(null);

  useEffect(() => {
    const draggable = new Draggable(dragRef.current, {
      eventData: () => ({
        title: event.title,
        id: event.id,
        allDay: event.isAllDay,
        extendedProps: { ...event.extendedProps },
      }),
    });

    return () => {
      draggable.destroy();
    };
  }, [event]);

  return (
    <Paper
      ref={dragRef}
      variant="outlined"
      sx={{
        p: 1.5,
        mb: 1,
        borderRadius: 2,
        // backgroundColor: event.backgroundColor || 'primary.main',
        color: "black",
        borderLeft: `4px solid ${event.borderColor || "#1976d2"}`, // Left border highlight
        boxShadow: "none",
        cursor: "move",
        userSelect: "none",
      }}
      data-event-id={event.id}
      data-all-day={event.isAllDay}
     
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        {/* <Avatar sx={{ bgcolor: 'white', color: 'black', fontSize: 14 }}>
          {event.extendedProps?.initials || event.title?.charAt(0)}
        </Avatar> */}
        <Box sx={{display:"flex",gap:"1rem",alignItems:"center",justifyContent:"space-between",width:"100%"}}>
          <Typography fontWeight={500}>{event.title}</Typography>
           <IconButton  onClick={() => {
        onClick(event.id);
      }} ><Visibility/></IconButton>
        </Box>
       
      </Stack>
    </Paper>
  );
};

const WorkorderNotAssignList = ({ events, open, handleOpen }) => {
  const [woId, setWoId] = useState("");
  const [workorderView, setWOView] = useState(false);

  const handleWorkorderView = () => {
    setWoId("");
    setWOView(false);
  };

  return (
    <Box
      id="external-events"
      sx={{
        width: 350,
        // maxHeight: "50vh",
        // overflowY: "auto",
        p: 2,
        borderRadius: 2,
        border: "1px solid #ddd",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "0.5rem",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={handleOpen}
      >
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Unscheduled Orders ({events.length})
        </Typography>
        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </Box>

      <Collapse in={open} sx={{ maxHeight: "50vh", overflowY: "auto" }}>
        {events.map((event) => (
          <ExternalEvent key={event.id} event={event} 
          onClick={(e) => {
            setWOView(true)
            setWoId(e)
          }} 
          />
        ))}
      </Collapse>
      <ResponsiveDialog
        open={workorderView}
        onClose={handleWorkorderView}
       PaperProps={{
    sx: {
      maxWidth: '90vw', // set max width in viewport width
      width: '100%',     // optional, ensures it can grow to max
    }
  }}
        children={<WO handleCloseClick={handleWorkorderView} woId={woId} />}
      />
    </Box>
  );
};

export default WorkorderNotAssignList;
